// Custom theme overrides and client-specific behavior
// Keep this file for customizations to ease theme updates.

(function(){
  'use strict';

  var BaseModalElement = (window.customElements && (window.customElements.get('basic-modal') || window.customElements.get('modal-component'))) || null;
  if (BaseModalElement && !window.customElements.get('stock-limit-modal')) {
    var StockLimitModalElement = class extends BaseModalElement {
      connectedCallback() {
        if (super.connectedCallback) {
          super.connectedCallback();
        }
        var self = this;
        if (!this._stockLimitCloseHandler) {
          this._stockLimitCloseHandler = function(event) {
            if (event.target.closest('[data-stock-limit-close]')) {
              event.preventDefault();
              self.hide();
            }
          };
        }
        this.addEventListener('click', this._stockLimitCloseHandler);

        if (!this._stockLimitOverlayHandler) {
          this._stockLimitOverlayHandler = function(event) {
            if (event.target.classList.contains('fixed-overlay')) {
              event.preventDefault();
              self.hide();
            }
          };
        }
        if (this.overlay) {
          this.overlay.addEventListener('click', this._stockLimitOverlayHandler);
        }
      }

      disconnectedCallback() {
        if (this._stockLimitCloseHandler) {
          this.removeEventListener('click', this._stockLimitCloseHandler);
        }
        if (this._stockLimitOverlayHandler && this.overlay) {
          this.overlay.removeEventListener('click', this._stockLimitOverlayHandler);
        }
        if (super.disconnectedCallback) {
          super.disconnectedCallback();
        }
      }

      get focusElement() {
        return this.querySelector('[data-stock-limit-primary]') || super.focusElement;
      }
    };

    window.customElements.define('stock-limit-modal', StockLimitModalElement);
  }

  var StockLimitModalManager = {
    awaitingDom: false,
    cartErrorSubscribed: false,
    modal: null,
    productContainer: null,
    productValueEl: null,
    systemContainer: null,
    systemValueEl: null,
    titleEl: null,
    bodyEl: null,
    defaultBodyText: '',
    defaultTitleText: '',
    primaryButton: null,
  };

  StockLimitModalManager.init = function(force) {
    if (this.modal && !force) return true;
    this.modal = document.getElementById('StockLimitModal');
    if (!this.modal) {
      if (!this.awaitingDom) {
        this.awaitingDom = true;
        document.addEventListener(
          'DOMContentLoaded',
          function(){
            StockLimitModalManager.init(true);
          },
          { once: true }
        );
      }
      return false;
    }

    this.productContainer = this.modal.querySelector('[data-stock-limit-product]');
    this.productValueEl = this.modal.querySelector('[data-stock-limit-product-text]');
    this.systemContainer = this.modal.querySelector('[data-stock-limit-system]');
    this.systemValueEl = this.modal.querySelector('[data-stock-limit-system-text]');
    this.titleEl = this.modal.querySelector('[data-stock-limit-title]');
    this.bodyEl = this.modal.querySelector('[data-stock-limit-body]');
    this.primaryButton = this.modal.querySelector('[data-stock-limit-primary]');
    this.defaultBodyText = this.bodyEl ? this.bodyEl.textContent.trim() : '';
    this.defaultTitleText = this.titleEl ? this.titleEl.textContent.trim() : '';
    this.initCartErrorSubscription();
    return true;
  };

  StockLimitModalManager.initCartErrorSubscription = function() {
    if (this.cartErrorSubscribed) return;
    if (!window.FoxTheme || !FoxTheme.pubsub) return;
    this.cartErrorSubscribed = true;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, function(payload){
      var message = payload && (payload.errors || payload.message);
      var productTitle = payload && payload.productTitle;
      StockLimitModalManager.maybeShow(message, {
        source: payload && payload.source,
        productTitle: productTitle,
      });
    });
  };

  StockLimitModalManager.sanitizeMessage = function(rawMessage) {
    if (!rawMessage) return '';
    if (typeof rawMessage === 'string') return this.stripHtml(rawMessage);
    if (Array.isArray(rawMessage)) return this.sanitizeMessage(rawMessage.join(' '));
    if (typeof rawMessage === 'object') return this.sanitizeMessage(Object.values(rawMessage).join(' '));
    return '';
  };

  StockLimitModalManager.stripHtml = function(value) {
    var buffer = document.createElement('div');
    buffer.innerHTML = value;
    return (buffer.textContent || buffer.innerText || '').replace(/\s+/g, ' ').trim();
  };

  StockLimitModalManager.extractQuantity = function(message) {
    if (!message) return null;
    var match = message.match(/(\d{1,4})\s*(?:stk|stykker|varer|enheder)?/i);
    if (!match) return null;
    var value = parseInt(match[1], 10);
    return isNaN(value) ? null : value;
  };

  StockLimitModalManager.formatQuantityLabel = function(quantity) {
    if (!quantity) return '';
    return quantity + ' stk';
  };

  StockLimitModalManager.updateContent = function(systemMessage, context) {
    context = context || {};
    var derivedQuantity = context.quantity || this.extractQuantity(systemMessage);
    var quantityLabel = this.formatQuantityLabel(derivedQuantity);

    if (this.titleEl) {
      if (quantityLabel) {
        this.titleEl.textContent = 'Kun ' + quantityLabel + ' tilføjet til kurven';
      } else if (this.defaultTitleText) {
        this.titleEl.textContent = this.defaultTitleText;
      }
    }
    if (this.bodyEl) {
      if (quantityLabel) {
        this.bodyEl.textContent = 'Vi kunne kun tilføje ' + quantityLabel + ' lige nu. Resten er ikke tilgængelige.';
      } else if (this.defaultBodyText) {
        this.bodyEl.textContent = this.defaultBodyText;
      }
    }
    if (this.productContainer && this.productValueEl) {
      var title = (context.productTitle || '').trim();
      this.productContainer.hidden = !title;
      this.productValueEl.textContent = title;
    }
    if (this.systemContainer && this.systemValueEl) {
      this.systemContainer.hidden = !systemMessage;
      this.systemValueEl.textContent = systemMessage;
    }
  };

  StockLimitModalManager.openModal = function() {
    if (!this.modal) return;
    if (typeof this.modal.show === 'function') {
      this.modal.show(this.primaryButton || null);
    } else {
      this.modal.removeAttribute('hidden');
      this.modal.setAttribute('open', '');
      var focusTarget = this.primaryButton || this.modal.querySelector('[data-stock-limit-close]');
      if (focusTarget) {
        focusTarget.focus();
      }
    }
  };

  StockLimitModalManager.maybeShow = function(message, context) {
    context = context || {};
    if (!this.init()) return false;
    var cleanMessage = this.sanitizeMessage(message);
    this.updateContent(cleanMessage, context);
    this.openModal();
    return true;
  };

  window.StockLimitModalManager = StockLimitModalManager;

  // Sanitize Odoo bilag links in product "Dokumenter" accordion
  function sanitizeBilag() {
    var lists = document.querySelectorAll('.odoo-bilag');
    lists.forEach(function(ul){
      var links = ul.querySelectorAll('a.bilag-link, a');
      links.forEach(function(link){
        var url = (link.getAttribute('data-url') || link.getAttribute('href') || '').trim();
        var lower = url.toLowerCase();
        var isFile = /\.(pdf|docx?|xlsx?|pptx?)(?:$|[?#])/i.test(lower);
        var hasProtocol = /^(https?:)?\/\//i.test(url);
        var isCdn = lower.indexOf('/cdn/') !== -1 || lower.indexOf('/files/') !== -1;
        var isValid = hasProtocol || isCdn || isFile;

        if (!isValid) {
          var li = link.closest('li');
          if (li) li.remove();
          return;
        }

        if (isFile) {
          var name = decodeURIComponent(url.split('/').pop().split('?')[0]).replace(/[\-_]+/g, ' ').trim();
          link.textContent = name || url;
          return;
        }

        // Fetch HTML title for non-file URLs
        fetch(url)
          .then(function(res){
            var ct = (res.headers.get('content-type') || '').toLowerCase();
            if (ct.indexOf('text/html') === -1) throw new Error('non-html');
            return res.text();
          })
          .then(function(html){
            var match = html.match(/<title>(.*?)<\/title>/i);
            link.textContent = (match && match[1]) ? match[1].trim() : url;
          })
          .catch(function(){
            var fallback = decodeURIComponent(url.split('/').pop().split('?')[0]).replace(/[\-_]+/g, ' ').trim();
            if (!link.textContent || link.textContent === 'Indlæser titel...') link.textContent = fallback || url;
          });
      });

      if (!ul.querySelector('li')) ul.remove();
    });
  }

  function hideEmptyAccordionItems() {
    var needle = 'vi har i øjeblikket ingen';
    var contents = document.querySelectorAll('.accordion-details__content');

    contents.forEach(function(content){
      var text = (content.textContent || '').toLowerCase();
      if (text.indexOf(needle) === -1) return;

      var item = content.closest('.accordion-item');
      if (item) {
        item.hidden = true;
      }
    });
  }

  function initCollectionColumnsSwitcher() {
    var switcher = document.querySelector('[data-columns-switcher]');
    if (!switcher) return;

    if (!switcher.dataset.columnsInitialized) {
      switcher.dataset.columnsInitialized = 'true';
      switcher.addEventListener('click', function(event) {
        var button = event.target.closest('button[data-columns]');
        if (!button || !switcher.contains(button)) return;

        var value = parseInt(button.getAttribute('data-columns'), 10);
        if (!value) return;

        applyCollectionColumns(value);
        storeCollectionColumns(value);
      });
    }

    var initial = getStoredCollectionColumns() || getDefaultCollectionColumns();
    if (initial) applyCollectionColumns(initial);
  }

  function getDefaultCollectionColumns() {
    var grid = document.getElementById('ProductsList');
    if (!grid) return null;
    var fallback = parseInt(grid.dataset.columnsDefault || '', 10);
    return Number.isFinite(fallback) ? fallback : null;
  }

  function getStoredCollectionColumns() {
    if (!window.FoxTheme || !FoxTheme.config || !FoxTheme.config.hasLocalStorage) return null;
    var value = parseInt(window.localStorage.getItem('hypertheme:collection-columns') || '', 10);
    if (![4, 5, 6].includes(value)) return null;
    return value;
  }

  function storeCollectionColumns(value) {
    if (!window.FoxTheme || !FoxTheme.config || !FoxTheme.config.hasLocalStorage) return;
    window.localStorage.setItem('hypertheme:collection-columns', String(value));
  }

  function applyCollectionColumns(value) {
    var grid = document.getElementById('ProductsList');
    if (!grid) return;

    grid.style.setProperty('--f-columns-xl', value);
    grid.dataset.columnsCurrent = String(value);

    var switcher = document.querySelector('[data-columns-switcher]');
    if (!switcher) return;
    switcher.querySelectorAll('button[data-columns]').forEach(function(button){
      var isActive = parseInt(button.getAttribute('data-columns'), 10) === value;
      button.classList.toggle('btn--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    StockLimitModalManager.init(true);
    sanitizeBilag();
    setTimeout(sanitizeBilag, 100);
    hideEmptyAccordionItems();
    setTimeout(hideEmptyAccordionItems, 100);
    initCollectionColumnsSwitcher();
    document.addEventListener('collection:rerendered', initCollectionColumnsSwitcher);

    // Mini ATC label: show '+' if text would overflow, with hysteresis to avoid flicker.
    // All reads happen before any writes, and the text is measured on a canvas, so a grid of
    // cards costs one layout instead of one forced layout per button.
    var miniAtcCanvas = null;
    var miniAtcWidths = {};
    function measureMiniATCText(text, cs) {
      var transform = cs.textTransform;
      if (transform === 'uppercase') text = text.toUpperCase();
      else if (transform === 'lowercase') text = text.toLowerCase();
      else if (transform === 'capitalize') text = text.replace(/(^|\s)(\S)/g, function(m, sp, ch){ return sp + ch.toUpperCase(); });
      var font = [cs.fontStyle, cs.fontWeight, cs.fontSize, cs.fontFamily].join(' ');
      var spacing = parseFloat(cs.letterSpacing) || 0;
      var key = font + '|' + spacing + '|' + text;
      if (miniAtcWidths[key] === undefined) {
        if (!miniAtcCanvas) miniAtcCanvas = document.createElement('canvas').getContext('2d');
        miniAtcCanvas.font = font;
        miniAtcWidths[key] = Math.ceil(miniAtcCanvas.measureText(text).width + spacing * text.length);
      }
      return miniAtcWidths[key];
    }

    function updateMiniATCLabels(scope) {
      var container = scope || document;
      var buttons = container.querySelectorAll('.btn--mini-atc');

      // Hysteresis thresholds (px): enter compact sooner, exit compact later
      var ENTER_MARGIN = 8;   // become '+' a bit before true overflow
      var EXIT_MARGIN = 20;   // require extra space to restore text

      // Read phase: no DOM writes in this loop
      var changes = [];
      var now = performance.now();
      buttons.forEach(function(btn){
        var span = btn.querySelector('.btn__text');
        if (!span) return;

        var fullText = span.getAttribute('data-full-text') || span.textContent;
        var width = btn.clientWidth;
        if (!width) return; // hidden (e.g. list view or a closed slider): nothing to decide yet

        // Available inner width inside the button (excluding padding)
        var csBtn = window.getComputedStyle(btn);
        var padX = parseFloat(csBtn.paddingLeft) + parseFloat(csBtn.paddingRight);
        var avail = Math.max(0, width - padX);
        var fullWidth = measureMiniATCText(fullText, window.getComputedStyle(span));

        var isCompact = btn.classList.contains('btn--mini-atc--compact');
        var wantCompact = isCompact ? avail < fullWidth + EXIT_MARGIN
                                    : avail < fullWidth + ENTER_MARGIN;

        // Throttle rapid toggles
        var canToggle = (now - (btn.__miniAtcLastToggle || 0)) > 200; // ms
        changes.push({ btn: btn, span: span, fullText: fullText, toggle: wantCompact !== isCompact && canToggle, compact: wantCompact });
      });

      // Write phase
      changes.forEach(function(c){
        // Persist original label
        if (!c.span.getAttribute('data-full-text')) c.span.setAttribute('data-full-text', c.fullText);
        if (!c.toggle) return;
        c.btn.__miniAtcLastToggle = now;
        if (c.compact) {
          c.span.textContent = '+';
          c.btn.classList.add('btn--mini-atc--compact');
          if (!c.btn.getAttribute('aria-label')) c.btn.setAttribute('aria-label', c.fullText);
        } else {
          c.span.textContent = c.fullText;
          c.btn.classList.remove('btn--mini-atc--compact');
          c.btn.removeAttribute('aria-label');
        }
      });
    }

    // Initial run and on resize
    var rafId;
    function scheduleUpdate(){
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function(){ updateMiniATCLabels(); });
    }
    // Run immediately to avoid any visible truncation, then a couple of rAF passes
    updateMiniATCLabels();
    scheduleUpdate();
    requestAnimationFrame(scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);
    // Canvas measures with the fallback font until the web font has loaded
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleUpdate);

    // Observe product card sliders/lazy render
    var ro = new ResizeObserver(function(){ scheduleUpdate(); });
    document.querySelectorAll('.product-card__mini-form').forEach(function(el){ ro.observe(el); });

    // Cards added later (theme load-more, smart filter injection, facet re-render) need the same
    // treatment; observing them makes the ResizeObserver run once for each new card.
    var gridObserver = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if (node.nodeType !== 1) return;
          if (node.matches('.product-card__mini-form')) ro.observe(node);
          node.querySelectorAll('.product-card__mini-form').forEach(function(el){ ro.observe(el); });
        });
      });
    });
    function watchProductGrid(){
      gridObserver.disconnect();
      var grid = document.getElementById('ProductsList');
      if (!grid) return;
      gridObserver.observe(grid, { childList: true });
      grid.querySelectorAll('.product-card__mini-form').forEach(function(el){ ro.observe(el); });
    }
    watchProductGrid();
    document.addEventListener('collection:rerendered', watchProductGrid);
  });
})();


/* App overwrites */
const rmtb = () => {
  const elements = document.querySelectorAll(
    "div.MagicToolboxContainer span a"
  );

  elements.forEach(el => {
    if (el.textContent.toLowerCase().includes("trial version")) {
      el.remove();
    }
  });
};

// First cleanup on page load
rmtb();

// Observe future changes
const observer = new MutationObserver(() => rmtb());

observer.observe(document.body, {
  childList: true,
  subtree: true
});

/* Faster navigation: prefetch internal pages on hover/press (Speculation Rules in Chromium,
   <link rel="prefetch"> fallback elsewhere). Prefetch only, never prerender, and never cart/checkout/account. */
(function(){
  'use strict';
  try {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      var rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({
        prefetch: [{
          where: { and: [
            { href_matches: '/*' },
            { not: { href_matches: ['/cart', '/cart/*', '/checkout*', '/account*', '/search*', '/apps/*', '/*logout*', '/*add*'] } },
            { not: { selector_matches: ['[rel~=nofollow]', '[target=_blank]', 'a[download]', '[data-no-prefetch]'] } }
          ] },
          eagerness: 'moderate'
        }]
      });
      document.head.appendChild(rules);
      return;
    }

    var done = {}, timer;
    var skip = /^\/(cart|checkout|account|search|apps)(\/|$)|logout|add/;
    function prefetch(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || a.target === '_blank' || a.hasAttribute('download')) return;
      if (skip.test(a.pathname) || done[a.href] || a.href === location.href) return;
      done[a.href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      document.head.appendChild(l);
    }
    document.addEventListener('mouseover', function(e){ clearTimeout(timer); timer = setTimeout(function(){ prefetch(e); }, 120); }, { passive: true });
    document.addEventListener('mouseout', function(){ clearTimeout(timer); }, { passive: true });
    document.addEventListener('mousedown', prefetch, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });
  } catch (err) {}
})();

/* Same-page #anchor links scroll smoothly; the offset below the sticky header comes from scroll-padding-top in custom.css.
   Hyper skips rendering of sections 3+ for ~6 s after load (content-visibility: auto with a 600px placeholder, theme.css
   [data-initializing]), so the sections above the target are rendered first, or the scroll overshoots. */
(function () {
  function reveal(t) {
    var sec = t.closest('.shopify-section');
    while (sec && (sec = sec.previousElementSibling)) sec.style.contentVisibility = 'visible';
  }
  function target(hash) {
    try { return hash.length > 1 && document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { return null; }
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank' || a.hasAttribute('aria-controls') || a.hasAttribute('aria-expanded') || a.getAttribute('role') === 'button') return;
    if (a.origin !== location.origin || a.pathname !== location.pathname || a.search !== location.search) return;
    var t = target(a.hash);
    if (!t || !t.getClientRects().length) return;
    e.preventDefault();
    reveal(t);
    t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (location.hash !== a.hash) history.pushState(null, '', a.hash);
    if (a.classList.contains('skip-to-content-link')) t.focus({ preventScroll: true });
  });

  // Landing on a URL with a #hash: the browser's own jump can overshoot while sections are still placeholders
  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var t = location.hash && (!nav || nav.type === 'navigate') && target(location.hash);
  if (t) { reveal(t); t.scrollIntoView({ block: 'start' }); }
})();
